import './App.scss';
import routers from './routes/routerConfig';
import { useRoutes } from 'react-router-dom';
function App() {
  const elements = useRoutes(routers);
  return <>{elements}</>;
}

export default App;
